import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import MetricCards from './analytics/MetricCards';
import DeploymentCharts from './analytics/DeploymentCharts';
import BankCharts from './analytics/BankCharts';
import CustomerSatisfaction from './analytics/CustomerSatisfaction';
import GuardsAnalytics from './analytics/GuardsAnalytics';
import StaffAnalyticsCharts from './analytics/StaffAnalyticsCharts';

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[6]};
`;

const MainRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${theme.spacing[6]};
  margin-bottom: ${theme.spacing[6]};

  @media (max-width: ${theme.breakpoints.xl}) {
    grid-template-columns: 1fr;
  }
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[6]};
`;

const DeploymentRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${theme.spacing[6]};

  @media (max-width: ${theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

const BottomRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${theme.spacing[6]};

  @media (max-width: ${theme.breakpoints.xl}) {
    grid-template-columns: 1fr;
  }
`;

const DashboardBody: React.FC = () => {
  return (
    <BodyContainer>
      <MetricCards />
      <MainRow>
        <LeftColumn>
          <DeploymentRow>
            <DeploymentCharts />
          </DeploymentRow>
        </LeftColumn>
        <BankCharts />
      </MainRow>
      <BottomRow>
        <CustomerSatisfaction />
        <BankCharts showBankGuardsOnly />
      </BottomRow>
      <MainRow>
        <GuardsAnalytics />
        <StaffAnalyticsCharts />
      </MainRow>
    </BodyContainer>
  );
};

export default DashboardBody;

